module.exports = __webpack_public_path__ + "img/restauri_esterni.91b3c221.jpg";